<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Informasi Umum</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Informasi</b-col>
                    <b-col>{{ Informasi.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Informasi</b-col>
                    <b-col>{{ Informasi.jenis.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Rilis</b-col>
                    <b-col>{{$helper.changeDateFormat(Informasi.tanggalRilis)}} {{$helper.changeDateFormatGetHour(Informasi.tanggalRilis)}}</b-col>
                </b-row>
                <b-row class="mb-2" v-if="Informasi.tanggalPerubahanTerakhir != 'null'">
                    <b-col cols="4" class="detail-data-label">Tanggal Perubahan Terakhir</b-col>
                    <b-col>{{$helper.changeDateFormat(Informasi.tanggalPerubahanTerakhir)}} {{$helper.changeDateFormatGetHour(Informasi.tanggalPerubahanTerakhir)}}</b-col>
                </b-row>
                <b-row class="mb-2" v-else>
                    <b-col cols="4" class="detail-data-label">Tanggal Perubahan Terakhir</b-col>
                    <b-col>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Download File</b-col>
                    <b-col>
                        <a :href="$baseFilePath+Informasi.path" target="_blank" download>Buka File</a>
                    </b-col>
                </b-row>
            </div>
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" name="InformasiUmumEditBtn" @click="editInformasiUmum">Edit</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'detail-Informasi-umum',
    data(){
        return{
            id: null,
            initStatus: 0,
            Informasi: []
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleInformasi = this.$axios.get(`informasi-umum/${this.id}`).then(response => {
                this.Informasi = response.data

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleInformasi]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Lain -----------------

        editInformasiUmum(){
            this.$router.push({path: `${this.$route.path}/edit`});
        }
    },

    created(){
        this.init()
    }
}
</script>
